import { t } from "i18next";
import * as z from "zod";

import { KYC_DOCUMENT_TYPES, UPLOADED_VIA } from "@/features/shared/api/enums";

/**
 * Schémas des formulaires de pièces justificatives KYC — factory (règle
 * projet) : créés via `create…Schema()` et mémoïsés au niveau composant sur
 * la langue courante, jamais d'instance exportée figée.
 */

/** Zone d'upload (le fichier lui-même est validé au niveau composant). */
export const createKycDocumentUploadSchema = () =>
  z.object({
    documentType: z.enum(KYC_DOCUMENT_TYPES, {
      errorMap: () => ({ message: t("requiredFieldError") }),
    }),
    uploadedVia: z.enum(UPLOADED_VIA, {
      errorMap: () => ({ message: t("requiredFieldError") }),
    }),
  });

/** Rejet d'une pièce : le motif est OBLIGATOIRE (guide §6.2). */
export const createKycDocumentRejectSchema = () =>
  z.object({
    reason: z.string().trim().min(1, { message: t("requiredFieldError") }),
  });

export type KycDocumentUploadFormValues = z.infer<
  ReturnType<typeof createKycDocumentUploadSchema>
>;
export type KycDocumentRejectFormValues = z.infer<
  ReturnType<typeof createKycDocumentRejectSchema>
>;
